import React from 'react';
import { type BuyerLayoutProps } from 'app/shop-ui';
import { getDisplayPrice } from 'app/libs/getDisplayPrice';
import './ssr.scss';

interface ProductCardPropType extends BuyerLayoutProps<Product & BuyerPromoProduct> {}

export const ProductCard: React.FC<ProductCardPropType> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    const displayPrice = getDisplayPrice({
        originalPrice: product?.price,
        discountedPrice: product?.discounted_price,
        minAddOnPrice: product?.min_add_on_price,
        promoSavingPrice: null,
    });

    const id = product?.id || '';

    const name = product?.name || '';

    return (
        <a href={`/product/${id}`} className="ssr-product-card">
            <div className="skeleton skeleton--ssr skeleton--full"></div>

            <div className="skeleton-spacer"></div>

            <strong className="skeleton skeleton--ssr skeleton--sm">
                <p className="ssr-hidden">{name}</p>
            </strong>

            <div className="skeleton-spacer"></div>

            <div>
                <div className="skeleton skeleton--ssr skeleton--xs">
                    {displayPrice.useDiscountedPrice && displayPrice.discountedPrice && (
                        <span className="ssr-hidden">
                            {displayPrice.discountedPrice?.value}
                        </span>
                    )}
                    <b className="ssr-hidden">{displayPrice.originalPrice?.value}</b>
                </div>
            </div>
        </a>
    );
};
